<script>
export default {
  props: {
    text: String,
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked: this.checked
    };
  },
  methods: {
    click() {
      this.$emit("click", !this.isChecked);
      this.isChecked = !this.isChecked;
    }
  }
};
</script>

<template>
  <div class="CheckedItem" @click="click">
    <span :class="isChecked ? 'checked' : 'unChecked'">{{text}}</span>
  </div>
</template>

<style lang="scss" scoped>
.CheckedItem {
  display: inline-block;
  cursor: pointer;
  margin: 5px 3px;
  font-size: 14px;

  > span {
    display: inline-block;
    padding: 5px 25px 5px 10px;
    border-radius: 6px;
  }
  .checked {
    border: 1px solid #00c1de;
    color: #00c1de;
    background-image: url("./assets/noteCheckedBlue.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
  }
  .unChecked {
    border: 1px solid #e8e8e8;
    color: #8d8d8d;
    background-image: url("./assets/noteCheckedGray.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
  }
}
</style>





// WEBPACK FOOTER //
// yotta-vue-components/vision/CheckedItem.vue